import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-190c4e65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "cols info" }
const _hoisted_3 = { class: "cols" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!

  return (_openBlock(), _createBlock(_component_drive_ui_wrapper, {
    hideBorder: _ctx.HIDE_BORDER.BOTTOM
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$localize('drive.creation.info.created')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$localize('drive.creation.info.updated')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(_ctx.created), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.updated), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["hideBorder"]))
}